import { default as domainScenario } from './scenario/services'

export default {
    domainScenario
}
